import React from 'react';
import { getMovementStyles } from '../utils/styles';
import { User } from 'lucide-react';

const MovementCard = ({ movement, lot }) => {
  const styles = getMovementStyles(movement.type);

  return (
    <div className={`p-4 rounded-lg shadow-md border-l-4 ${styles.border} ${styles.bg} bg-white dark:bg-gray-800`}>
      <div className="flex justify-between items-start">
        <div className="space-y-1">
          <div className="text-xl font-bold text-gray-800 dark:text-white">{lot.display_id || lot.id}</div>
          <div className="text-lg text-gray-700 dark:text-gray-200">{lot.title}</div>
          <div className={`text-sm font-medium ${styles.text} flex items-center`}>
            <span className="mr-1">{styles.icon}</span>
            {styles.label}
          </div>
          {movement.note && (
            <div className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              {movement.note}
            </div>
          )}
          {movement.auth_user_id && (
            <div className="text-xs text-gray-500 dark:text-gray-400 mt-1 flex items-center">
              <User className="w-3 h-3 mr-1" />
              {movement.auth_user_id}
            </div>
          )}
        </div>
        <div className="text-right">
          <div className="text-xl font-bold text-gray-800 dark:text-white">
            {movement.quantity} {movement.unit_sign}
          </div>
          <div className="text-sm text-gray-500 dark:text-gray-400">
            {new Date(movement.timestamp).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit'
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovementCard; 